import React, { useState, useEffect } from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import Button, { ButtonWrapper } from "ds/Button";
import Checkbox from "ds/Checkbox";
import Modal from "ds/Modal";

import * as S from "./DeactivateEnvModal.style";

import type { Environment, Project } from "@packages/client";

interface Props {
  confirmDeactivateModal: boolean;
  closeModal: () => void;
  environment: Environment;
  project?: Project;
  acceptDeactivate?: boolean;
  acceptDeactivateToggle?: () => void;
  toggleEnvironmentActivation: () => void;
}

export const DeactivateEnvModal = ({
  confirmDeactivateModal,
  closeModal,
  environment,
  project,
  toggleEnvironmentActivation
}: Props) => {
  const intl = useIntl();
  const [acceptDeactivate, setAcceptDeactivate] = useState(false);
  useEffect(() => {
    setAcceptDeactivate(false);
  }, []);

  const acceptDeactivateToggle = () => {
    setAcceptDeactivate(prevValue => !prevValue);
  };
  const onCancelClick = () => {
    closeModal();
    setAcceptDeactivate(false);
  };

  return (
    <Modal
      isOpen={confirmDeactivateModal}
      onOpenChange={onCancelClick}
      handleClose={onCancelClick}
      size="medium"
    >
      <Typography.Title tag="h2">
        {intl.formatMessage({ id: "deactivate_environment" })}
      </Typography.Title>
      <Typography.BodyText>
        <span>
          {intl.formatMessage({
            id: "deactivate_confirm_text"
          })}{" "}
          <strong>{environment?.title}</strong>{" "}
          {intl.formatMessage({ id: "from" })} <strong>{project?.title}</strong>
          ?
        </span>
      </Typography.BodyText>
      <S.AgreeWrapper>
        <Checkbox
          label={intl.formatMessage({
            id: "status_active_delete_verify"
          })}
          id="verify"
          checked={acceptDeactivate}
          onCheckedChanged={acceptDeactivateToggle}
          forId="verify-delete"
          required
        />
      </S.AgreeWrapper>
      <ButtonWrapper justifyContent="end">
        <Button analyticId="cancel" variant="secondary" onClick={onCancelClick}>
          {intl.formatMessage({
            id: "cancel"
          })}
        </Button>
        <S.DeactivateButton
          disabled={!acceptDeactivate}
          analyticId="deactivate_confirm_button"
          onClick={() => {
            toggleEnvironmentActivation();
            closeModal();
          }}
        >
          {intl.formatMessage({
            id: "deactivate_confirm_button"
          })}
        </S.DeactivateButton>
      </ButtonWrapper>
    </Modal>
  );
};
